<script lang="ts">
    import {
        DRAWER_BUTTON_ELEMENT_NAME,
        DRAWER_POSITION,
    } from "@/constants/drawer";
    import ReviewsTheme from "@apps/reviews/components/ReviewsTheme/ReviewsTheme.svelte";
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import ReviewsStorefrontValuesService from "@apps/reviews/services/ReviewsStorefrontValuesService";
    import Icon from "@components_v2/Icon.svelte";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

    import DrawerButton from "@components/Drawer/DrawerButton.svelte";

    export let direction: DRAWER_POSITION;
    export let reviewsStorefrontValuesService: ReviewsStorefrontValuesService;
    export let i18n: GwI18n;

    const reviewsBranding$ =
        reviewsStorefrontValuesService.selectReviewsBrandingOptions();

    const drawer_button_title$ = i18n.selectT(
        "reviews.critical.ReviewsDrawerWidget",
        "drawer_button_title"
    );

    const iconCollection$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();
</script>

{#if $reviewsBranding$}
    <ReviewsTheme branding={$reviewsBranding$}>
        <div class="gw-rv-drawer-button-wrapper">
            <DrawerButton
                elementName={DRAWER_BUTTON_ELEMENT_NAME.reviews}
                title={$drawer_button_title$}
                ariaLabel="Open {$drawer_button_title$} sidebar"
                {direction}
                on:click
                on:mouseenter
            >
                <Icon
                    slot="icon"
                    class="gw-rv-drawer-button-icon"
                    width={16}
                    height={16}
                    title={$drawer_button_title$}
                    color={$reviewsBranding$.reviewsIconSettings.starColor}
                    stroke={$reviewsBranding$.reviewsIconSettings.starColor}
                >
                    <svelte:component this={$iconCollection$?.filled} />
                </Icon>
            </DrawerButton>
        </div>
    </ReviewsTheme>
{/if}

<style lang="postcss">
    .gw-rv-drawer-button-wrapper {
        --gw-drawer-btn-bg-color: var(--gw-rv-drawer-launcherBackgroundColor);
        --gw-drawer-btn-text-color: var(--gw-rv-drawer-launcherFontColor);
        --gw-drawer-btn-icon-bg-color: var(
            --gw-rv-drawer-launcherIconBackgroundColor
        );
    }
    :global(.gw-rv-drawer-button-icon) {
        color: var(--gw-rv-icon-starColor);
    }
</style>
